import candidates from "../modules/candidates/core/candidates-router"
import AdminLayout from "../Admin-layout.vue"
import resultsRouter from "../modules/results/core/results-router"
import slots from "../modules/slots/core/slots-router"
import reserved from "../modules/reserved/core/reserved-router"
import cbrAcc from "../modules/cbr_accounts/core/cbrAcc-router"
import courseManagment from "../modules/course_managment/core/cm-router"
import courseLeaders from "../modules/course_leaders/core/courseLeadersRouter"
import drivingSchools from '../modules/driving_schools/core/router'

import ROUTER_NAMES from "@/router/router-const"

export default {
  path: '/admin',
  component: AdminLayout,
  name: ROUTER_NAMES.CRM,
  children: [
    ...candidates,
    ...resultsRouter,
    ...slots,
    ...cbrAcc,
    ...courseManagment,
    ...courseLeaders,
    ...drivingSchools,
    {
      path: '*',
      redirect: {name: ROUTER_NAMES.NOT_FOUND}
    }
  ],
  meta: {
    requiresAuth: true
  }
}
